export default "__VITE_ASSET__CdHB70W4__"